import { ReactElement } from "react";

import { RepeatIcon } from "@chakra-ui/icons";
import { Center, Flex, FlexProps } from "@chakra-ui/react";

import { Button } from "ui/Button/Button";
import { CircleIcon } from "ui/CircleIcon/CircleIcon";
import { BodyM, HeaderS } from "ui/Typography/Typography";
import { isNotNullNorUndefined } from "utils/tsHelpers";

export type PagePlaceholderProps = {
  icon: ReactElement;
  title: string;
  subtitle?: React.ReactElement | string;
  ctaLabel?: string;
  onClickCta?: () => void;
  ctaVariant?: "primary" | "link";
} & FlexProps;

export function PagePlaceholder({
  icon,
  title,
  subtitle,
  ctaLabel,
  onClickCta,
  ctaVariant = "primary",
  ...rest
}: PagePlaceholderProps) {
  return (
    <Center h="100%" w="100%" {...rest}>
      <Flex direction="column" w="100%" align="center">
        <HeaderS textAlign="center">{title}</HeaderS>
        {isNotNullNorUndefined(subtitle) && (
          <BodyM mt="s100" textAlign="center">
            {subtitle}
          </BodyM>
        )}
        <CircleIcon mt="s300" icon={icon} />
        {ctaLabel && ctaVariant === "primary" && (
          <Button mt="s300" onClick={onClickCta} variant="primary" size="lg">
            {ctaLabel}
          </Button>
        )}
        {ctaLabel && ctaVariant === "link" && (
          <Button
            variant="link"
            mt="s500"
            size="xs"
            color="nightBlueFlink.500"
            leftIcon={<RepeatIcon boxSize="20px" />}
            onClick={onClickCta}
          >
            {ctaLabel}
          </Button>
        )}
      </Flex>
    </Center>
  );
}
